/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React, {useState} from "react";
import AddFaq from "./AddFaq";
import {addFaq, fetchFaqs} from "api";
import {triggerToast} from "helpers";

const AddFaqContainer = ({
  contentId,
  setFaqData,
  token,
  attachNewFaq,
  setToggleAddFaqPopup
}) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  let uploadFaq = {};

  const handleAddFaq = async () => {
    const trimmedTitle = title.trim();
    const trimmedDescription = description.trim();

    if (!trimmedTitle || !trimmedDescription) {
      triggerToast("Please add both FAQ title and description", "error");
      return;
    }

    setLoading(true);
    const payload = {
      // eslint-disable-next-line quote-props
      "content_id": contentId,
      question: trimmedTitle,
      answer: trimmedDescription
    };
    try {
      uploadFaq = await addFaq(token, payload);
      if (uploadFaq && uploadFaq.data.externalId) {
        triggerToast("Faq Added Successfully", "success");
        setTitle("");
        setDescription("");

        const createdFaq = uploadFaq.data;
        if (createdFaq) {
          attachNewFaq?.({
            ...createdFaq,
            question: createdFaq.question ?? trimmedTitle,
            answer: createdFaq.answer ?? trimmedDescription
          });
        }

        try {
          const fetchLatestFaqs = await fetchFaqs();
          setFaqData(fetchLatestFaqs.data.results);
        } catch (err) {
          console.log(err, "error");
        }

        setToggleAddFaqPopup?.(false);
      }
    } catch (err) {
      triggerToast("Error Adding Faq", "error");
    }
    setLoading(false);
  };

  return (
    <AddFaq
      description={description}
      handleAddFaq={handleAddFaq}
      loading={loading}
      setDescription={setDescription}
      setTitle={setTitle}
      title={title}
    />
  );
};

export default AddFaqContainer;
